import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Icon from '../../../common/icons/Icon';

class ShowDescription extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    description: PropTypes.string,
    image: PropTypes.string,
    name: PropTypes.string.isRequired,
    nextEpisode: PropTypes.string,
  };

  static defaultProps = {
    description: '',
    image: 'https://d27vybgvtr1dba.cloudfront.net/placeholder.jpg',
    nextEpisode: null,
  };

  render() {
    const { description, id, image, name } = this.props;

    return (
      <Link to={`/subscription/tv/${id}`} className="show__card">
        <div className="show-card__image" style={{ backgroundImage: `url(${image})` }}>
          <Icon icon="Arrow" />
        </div>
        <h3>{name}</h3>
        {description ? <p>{description}</p> : null}
      </Link>
    );
  }
}

export default ShowDescription;



// WEBPACK FOOTER //
// ./src/subscription/tv/common/ShowDescription.js